import React from 'react';
import styled from 'styled-components';
import { device } from '../../utils/responsive_utilities';
import { fontQuicksand } from './mixin';
import i18n from '../../utils/i18n';
import { t2EligibleUserOnTheBasisOfCountryCode } from '../../utils/web-helper';

export default function GameCount({activeFilterTab}) {
  // let {feature_1="", feature_2=""} = features.get(initialDuration)[0]["properties"];
  const features = {
    'ela': '4,000+ reading activities',
    'math': `4,000+ ${i18n.t('math')} activities`,
    'mela': `8,000+ ${i18n.t('math')} and reading activities`
  }
  const diplayLiveClassesChanges = t2EligibleUserOnTheBasisOfCountryCode();
  return (
    <Count moreThanOneRow={diplayLiveClassesChanges}>
      { (activeFilterTab.id === 'math') &&
        <span><i className="iconcust-iconTick"></i>{features['math']}</span>
      }
      { (activeFilterTab.id === 'ela') &&
        <span><i className="iconcust-iconTick"></i>{features['ela']}</span>
      }
      {
        (activeFilterTab.id === 'mela' &&
        <>
        <span><i className="iconcust-iconTick"></i>{features['mela']}</span>
          {diplayLiveClassesChanges && <span><i className="iconcust-iconTick"></i>{`Live Classes with expert teachers`}</span>}
        </>
        )
      }
    </Count>
  );
}

export const Count = styled.div`
  margin: 0 auto 4.5rem;
  justify-content: center;
  display: flex;
  flex-direction: column;
  font-weight: bold;
  width: 32rem;
  align-items: ${props => props.moreThanOneRow ? 'start' : 'center'};
  i {
    color: #EB6D45;
    font-size: 0.9rem;
    margin-right: 1rem;
  }
  @media ${device.PhoneLargeScreen} {
    padding: 1.6rem 2rem;
    ${fontQuicksand(1.2, 1.6, 5)}
    span {
      text-align: center;
    }
  }
  @media ${device.Phone} {
    width: 29rem;
    padding: 1.6rem 2rem;
    ${fontQuicksand(1.2, 1.6, 5)}
    span {
      text-align: center;
    }
  }
`

export const SummerText = styled.span`
  color: #FFC543;
  font-weight: bold;
  position: relative;
`

export const UnderlineImg = styled.span`
  position: absolute;
  display: flex;
  bottom: -0.3rem;
  left: 0;
  right: 0;
  width: 10.5rem;
  height: 0.4rem;
  @media ${device.Phone}, ${device.PhoneLargeScreen} {
    width: 9.5rem;
  }
  >img{
    width: 100%;
    height: 100%;
  }
`